import { getEnvironment } from '../enviroments';

const env = getEnvironment();

export const baseURL = env.baseURL;
export const GOOGLE_OAUTH_CLIENT_ID = env.GOOGLE_OAUTH_CLIENT_ID;
export const INDIVIDUAL_APP = env.INDIVIDUAL_APP;

//local storage keys to prevent naming collisions
export const SK_loginDetails = 'LOGIN_DETAILS';
export const SK_userSession = 'USER_SESSION';
export const SK_tempUserSession = 'TEMP_USER_SESSION';

//SESSION STORAGE KEYS
export const SK_newProductForm = 'NEW_PRODUCT_FORM';
